import { render, staticRenderFns } from "./redeemDetail.vue?vue&type=template&id=63d16fab&scoped=true"
import script from "./redeemDetail.vue?vue&type=script&lang=js"
export * from "./redeemDetail.vue?vue&type=script&lang=js"
import style0 from "./redeemDetail.vue?vue&type=style&index=0&id=63d16fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d16fab",
  null
  
)

export default component.exports